// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"Content__baseFont__1pXlV","content":"Content__content__Wy_Ou","baseColor":"Content__baseColor__1nkN0","baseFontFamily":"Content__baseFontFamily__Gi7Zn"};